import { WebPortalServerConfigV1, WebPortalServerConfigV1Schema } from '@csp/config-schemas';
import { Maybe, WebPortalServerConfig } from '@csp/csp-common-model';
import { JsonValidationService } from '@csp/csp-common-util';

export const DEFAULT_TIME_ZONE = 'UTC';

const toWebPortalServerConfig = (webPortalServerConfigV1: Maybe<WebPortalServerConfigV1>): WebPortalServerConfig => {
  if (webPortalServerConfigV1) {
    JsonValidationService.validateJsonNonStrict(
      'WebPortalServerConfig',
      WebPortalServerConfigV1Schema,
      webPortalServerConfigV1,
    );
  }

  return {
    defaultTimeZone: webPortalServerConfigV1?.defaultTimeZone ?? DEFAULT_TIME_ZONE,
  };
};

export const WebPortalServerConfigService = {
  toWebPortalServerConfig,
};
